<template>
  <f7-page class="home-page">
    <template #fixed>
      <MainHeaderComponent type="back" />
    </template>

    <div class="bg-gray title-container">
      <div class="title">
        <font-awesome-icon :icon="['fad', 'cog']" fixed-width />

        <div class="text">
          <h1>{{ $t.getTranslation('LBL_GRAPES_SAVE') }}</h1>
        </div>
      </div>

      <div class="button-container"></div>
    </div>

    <section class="form-container">
      <div class="container">
        <f7-list no-hairlines>
          <f7-list-item divider>{{ $t.getTranslation("LBL_GRAPES_DETAILS") }}</f7-list-item>
          <f7-list-input
            v-model:value="formData.GrapesCode"
            name="GrapesCode"
            :required="validationRules?.GrapesCode?.required"
            :minlength="validationRules?.GrapesCode?.minimumLength"
            :maxlength="validationRules?.GrapesCode?.maximumLength"
            :label="$t.getTranslation('LBL_GRAPES_CODE')"
            :placeholder="$t.getTranslation('LBL_TYPE_HERE')"
            :info="$t.getTranslation('LBL_INFO_FIELD_REQUIRED')"
            :error-message="$t.getLanguage() != 'EN' ? $t.getTranslation('LBL_ERROR_FIELD') : ''"
            floating-label
            outline
            type="text"
            :disabled="formData.GrapesId"
            validate
          >
          </f7-list-input>

          <f7-list-input
            v-model:value="formData.GrapesName['EN']"
            :name="GrapesName"
            :required="validationRules?.GrapesName?.required"
            :minlength="validationRules?.GrapesName?.minimumLength"
            :maxlength="validationRules?.GrapesName?.maximumLength"
            :label="$t.getTranslation('LBL_GRAPES_NAME_EN')"
            :placeholder="$t.getTranslation('LBL_TYPE_HERE')"
            :info="$t.getTranslation('LBL_INFO_FIELD_REQUIRED')"
            :error-message="$t.getLanguage() != 'EN' ? $t.getTranslation('LBL_ERROR_FIELD') : ''"
            floating-label
            outline
            type="text"
            validate
          >
          </f7-list-input>


          <f7-list-input
            v-model:value="formData.GrapesName['CHS']"
            :name="GrapesName"
            :required="validationRules?.GrapesName?.required"
            :minlength="validationRules?.GrapesName?.minimumLength"
            :maxlength="validationRules?.GrapesName?.maximumLength"
            :label="$t.getTranslation('LBL_GRAPES_NAME_CHS')"
            :placeholder="$t.getTranslation('LBL_TYPE_HERE')"
            :info="$t.getTranslation('LBL_INFO_FIELD_REQUIRED')"
            :error-message="$t.getLanguage() != 'EN' ? $t.getTranslation('LBL_ERROR_FIELD') : ''"
            floating-label
            outline
            type="text"
            validate
          >
          </f7-list-input>


  

          <div v-if="formData?.GrapesId">
            <f7-list-item>
               <ViewImageListComponent :title="$t.getTranslation('LBL_UPLOADED_IMAGES')" :data="uploadedImages" />
            </f7-list-item>

            <f7-segmented raised tag="p">
              <f7-button @click="upload('GRAPES_IMAGE')">{{  $t.getTranslation('LBL_UPLOAD_GRAPES_IMAGE') }}</f7-button>
            </f7-segmented>

            <!-- <f7-segmented raised tag="p">
              <f7-button @click="upload('SMALL_LOGO_IMAGE')">{{  $t.getTranslation('LBL_UPLOAD_SMALL_LOGO_IMAGE') }}</f7-button>
              <f7-button>{{  $t.getTranslation('LBL_UPLOAD_LARGE_LOGO_IMAGE') }}</f7-button>
            </f7-segmented> -->
          </div>
         
          <f7-button large fill raised preloader :loading="isButtonProcessing" :disabled="isButtonProcessing || isDisableSaveButton" @click="save">
              {{ $t.getTranslation("LBL_SAVE") }}
          </f7-button>

        </f7-list>
      </div>
    </section>

    <MainFooterComponent />
  </f7-page>
</template>

<script>
import { defineComponent, ref, computed, reactive, onMounted, inject } from "vue";

import { useStore } from "@/store";

import { $HTTP } from "@/utils/axios";
import { helpers } from "@/utils/helpers.js";

import { validations } from "@/utils/validations";
import validationRulesConfig from "@/validationRules";

import MainHeaderComponent from "@/components/MainHeaderComponent.vue";
import MainFooterComponent from "@/components/MainFooterComponent.vue";
import ViewImageListComponent from "@/components/ViewImageListComponent.vue";

export default defineComponent({
  name: "GrapesSavePage",
  components: {
    MainHeaderComponent,
    MainFooterComponent,
    ViewImageListComponent
  },
  props: { f7router: Object, f7route: Object },
  setup(props) {
    const $t = inject("$translation");
    const store = useStore();
    const isUpdate = ref(false);
    const isButtonProcessing = ref(false);
    const currentLanguageCode = computed(() => store.getters["translation/getLanguage"]);
    const uploadedImages = ref([]);
    const grapesId = ref(null);
    const formData = reactive({
      GrapesName: {
        EN: "",
        CHS: ""
      },
    });

    // uploadedImages.value.push({fields: "Identification", name: "Identification", link: helpers.getImage('http://localhost:3003/img/avatar_male.1e0b4bfd.svg', null, null, true)});

    let validationRules = {};
    for (let keys in formData) {
      if (validationRulesConfig && validationRulesConfig[keys]) {
        validationRules[keys] = validationRulesConfig[keys];
      }
    }

    onMounted(async() => {
      if (props?.f7route?.query && props?.f7route?.query?.GrapesId) {
        isUpdate.value = true;
        grapesId.value = props?.f7route?.query?.GrapesId;
        await getData();
      }
    });

    const getData = async () => {
      try {
        helpers.showLoader();
        let res = await $HTTP.get(`/admin/grapes/view?GrapesId=${grapesId.value}`);
        if (res?.status === 200 && res?.data?.data) {
          helpers.hideLoader();
          for (var key in res?.data?.data) {
            formData[key] = res?.data?.data[key];
          }

          for(const img of res.data.data.GrapesImages){
            let name;
            if (img.FieldName == "GrapesImage") {
              name = $t.getTranslation("LBL_GRAPES_IMAGE")
            }
            uploadedImages.value.push({fields: img.FieldName, name: name, link: helpers.getImage(img.FileName, "GRAPES")});
          }

          return;
        }
        throw new Error($t.getTranslation("ERR_SERVER_NOT_RESPONDING"));
      } catch (err) {
        helpers.hideLoader();
        helpers.catchError(err, true);
      }
    };

    const validate = (showNotifications) => {
      const isValid = validations.validate({
        validateData: formData,
        validationRules: validationRules,
        showNotifications: showNotifications,
      });

      return isValid;
    };

    const isDisableSaveButton = computed(() => {
      let isValid = validate(false);

      return !isValid;
    });

    const upload = (type) => {
      props.f7router.navigate({ name: "grapesUpload", params: {id: grapesId.value }, query: {type: type } });
    }

    const save = async () => {
      try {
        let isValid = validate(true);
        if (isValid) {
          isButtonProcessing.value = true;
          helpers.showLoader();
          formData.LanguageCode = currentLanguageCode.value;
          //send update to server
          let res = await $HTTP.post("/admin/grapes/save", formData);
          if (res?.status === 200 && res?.data?.data) {
            isButtonProcessing.value = false;
            helpers.hideLoader();
            //props.f7router.back({ force: true, ignoreCache: true });
            helpers.createNotification({ type: "success", title: $t.getTranslation("LBL_SUCCESS") , message: $t.getTranslation("LBL_SUCCESS_SAVE_GRAPES") });
            return;
          }

          throw new Error($t.getTranslation("ERR_SERVER_NOT_RESPONDING"));
        }
      } catch (err) {
        isButtonProcessing.value = false;
        helpers.hideLoader();
        helpers.catchError(err, true);
      }
    };

    return { isUpdate, formData, validationRules, isButtonProcessing, isDisableSaveButton, save, uploadedImages, upload };
  },
});
</script>
